
import { Observable, ObservedValuesFromArray } from 'rxjs';
import { CurriculaVMModel, CurriculumProductLevelPrice, CurriculumViewListing, 
  ExistingStudentCurriculumRegisterModel, PaymentFailureRedirectModel, PaymentProviderRequestResult, 
  PaymentSuccessRedirectModel, RegisterNewStudent, SelectedCurriculumModel, StudentCourseModel, 
  StudentModel, SelfGetLessonReturnModel, SelfServiceGetLessonModel, DemoRedirectModel, 
  GetDemoRedirectModel, ConsumerCurriculumJargon, StudentConsumerCurriculum, 
  LoginAsStudentModel, 
  DemoResultData,
  EmailConfirmationModel,
  ExistingStudentConsumerCurriculumRegisterModel,
  DiagnosticReportRequest,
  StandardsGrowthReportModel} from '../Elearning-Models';

import { IAPIService } from './API-Service/IAPIService';

export class CurriculumService {
  
  GetIsTeacher() : Observable<boolean> {
    return this.apiService.GetIsTeacher();
  }
  
  
  
  // Setting a default just to have something
  jargon: ConsumerCurriculumJargon = {DemoNoCaps:"diagnostic exam",DemoAllFirstLetterCaps:"Diagnostic Exam",DemoJustFirstLetterCaps:"Diagnostic exam"};
  
  
  constructor(private apiService: IAPIService) {
    this.GetConsumerCurriculumJargonFromAPI();
  }
  
  ValidateParentPassword(pass: string) : Observable<boolean> {
    return this.apiService.ValidateParentPassword(pass);
  }

  GetDemoResultData(studentConsumerCurriculumID: number): Observable<DemoResultData> {
    return this.apiService.GetDemoResultData(studentConsumerCurriculumID);
  }

  GetDemoResultDataByStudentAndClass(studentID: number, classID: number): Observable<DemoResultData> {
    return this.apiService.GetDemoResultDataByStudentAndClass(studentID, classID);
  }

  GetStudentConsumerCurriculum(StudentID: number, curriculumID: number) : Observable<StudentConsumerCurriculum> {
    return this.apiService.GetStudentConsumerCurriculum(StudentID, curriculumID)
  }
  
  GetCurriculumData(): Observable<CurriculaVMModel> {
    return this.apiService.GetCurriculumData();
  }

  AssignCurriculum(data: ExistingStudentCurriculumRegisterModel ): Observable<PaymentProviderRequestResult> {
    return this.apiService.AssignCurriculum(data);
  }

  AssignCurriculumByStudentConsumerCurriculumID(model: ExistingStudentConsumerCurriculumRegisterModel) : Observable<PaymentProviderRequestResult> {
    return this.apiService.AssignCurriculumForStudentConsumerCurriculum(model);
  }

  GetStudentList(): Observable<StudentModel[]> {
    return this.apiService.GetStudentList();
  }

  GetStudentLesson(model: SelfServiceGetLessonModel):Observable<SelfGetLessonReturnModel>{
    return this.apiService.GetStudentLesson(model);
  }

  LoginAndGetStudentDemo(model: SelfServiceGetLessonModel):Observable<SelfGetLessonReturnModel>{
    return this.apiService.LoginAndGetStudentDemo(model);
  }

  LoginAsStudent(model: LoginAsStudentModel):Observable<boolean>{
    return this.apiService.LoginAsStudent(model);
  }

  GetSelectedCurriculum(curriculumID: number): Observable<SelectedCurriculumModel> {
    return this.apiService.GetSelectedCurriculum(curriculumID);
  }

  RegisterNewStudent(model: RegisterNewStudent ): Observable<number> {
    return this.apiService.RegisterNewStudent(model);
  }

  GetStudentCourseList(): Observable<any> {
    return this.apiService.GetStudentCourseList();
  }

  GetCurriculumViewDataByClassId(classID: number): Observable<CurriculumViewListing> {
    return this.apiService.GetCurriculumViewDataByClassId(classID);
  }

  GetCurriculumProductLevelPrice(curriculumID: number) : Observable<CurriculumProductLevelPrice[]> {
    return this.apiService.GetCurriculumProductLevelPrice(curriculumID);
  }

  GetRedirectModelFromProcessPaymentFailure(guid: string) : Observable<PaymentFailureRedirectModel> {
    return this.apiService.GetRedirectModelFromProcessPaymentFailure(guid);
  }

  GetRedirectModelFromProcessPaymentSuccess(guid: string) : Observable<PaymentSuccessRedirectModel> {
    return this.apiService.GetRedirectModelFromProcessPaymentSuccess(guid);
  }

  GetDemoRedirect(model: GetDemoRedirectModel): Observable<DemoRedirectModel>{
    return this.apiService.GetDemoRedirect(model);
  }

  GetConsumerCurriculumJargonFromAPI(){
      this.apiService.GetConsumerCurriculumJargon().subscribe(result => {
        this.jargon = result;
      });
  } 

  GetConsumerCurriculumDiagnosticReport(model: DiagnosticReportRequest){
    return this.apiService.GetConsumerCurriculumDiagnosticReport(model);
  }

  IsConsumerCurriculum(){
    return this.apiService.IsConsumerCurriculum();
  }


  CheckIsNewComer(){
    return this.apiService.CheckIsNewComer();
  }

  ResendConfirmationEmail(guid: string): Observable<boolean>{
    return this.apiService.ResendConfirmationEmail(guid);
  }

  ConfirmEmail(guid: string): Observable<EmailConfirmationModel>{
    return this.apiService.ConfirmEmail(guid);
  } 

  ConfirmEmailByUser(): Observable<EmailConfirmationModel>{
    return this.apiService.ConfirmEmailByUser();
  }

  GetStandardsGrowthReport(classid: number): Observable<StandardsGrowthReportModel>{
    return this.apiService.GetStandardsGrowthReport(classid);
  }
}
